import { GuestCountValidation } from './types'

export const validateGuestCount = (guestCount: string): GuestCountValidation => {
  if (!guestCount.trim()) {
    return {
      isValid: false,
      error: 'Please enter the number of guests',
    }
  }

  const numericValue = Number(guestCount)
  if (isNaN(numericValue)) {
    return {
      isValid: false,
      error: 'Please enter a valid number',
    }
  }

  if (numericValue < 1) {
    return {
      isValid: false,
      error: 'Guest count must be at least 1',
    }
  }

  if (numericValue > 1000) {
    return {
      isValid: false,
      error: 'For guest counts over 1000, please contact us directly',
    }
  }

  return {
    isValid: true,
    error: '',
  }
}
